import logo from "@/assets/logo.png";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@simplicity/ui";
import { LogOut } from "lucide-react";

const Unauthorized = () => {
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="px-8 py-2 border-b border-border flex items-center bg-primary">
        <img src={logo} alt="Logo" className="h-9 w-auto" />
      </header>
      <main className="flex-1 flex items-center justify-center">
        <div className="flex flex-col items-center gap-6 p-10 border border-border rounded bg-card shadow-md max-w-sm w-full text-center">
          <h1 className="text-xl font-bold text-foreground">Access Denied</h1>
          <p className="text-sm text-muted-foreground">
            Your account has not been registered by an administrator. Please contact your admin to
            request access.
          </p>
          <Button
            onClick={() => {
              void signOut();
            }}
            className="w-full gap-2"
          >
            <LogOut className="h-4 w-4" />
            Sign Out
          </Button>
        </div>
      </main>
    </div>
  );
};

export default Unauthorized;
